// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// TAILSCALE HOST ALIAS SCHEMA
/////////////////////////////////////////

export const TailscaleHostAliasSchema = z.object({
  hostname: z.string(),
  ip: z.string(),
})

export type TailscaleHostAlias = z.infer<typeof TailscaleHostAliasSchema>

export default TailscaleHostAliasSchema;
